import gql from "graphql-tag";

import { FullComponentFragment } from "./component";
import { FullCustomerBenefitFragment } from "./customerBenefit";
import { FullTopicFragment } from "./topic";
import { FullVehicleFragment } from "./vehicle";
import { FullTopicClusterFragment } from "./topicCluster";
import { FullGeneralTranslationFragment } from "./generalTranslations";
import { FullEntryScreenItemFragment } from "./entryScreen";
import { FullPodcastsFragment } from "./podcasts";

export default gql`
    query allData($lang: Locale!, $stage: Stage!) {
        vehicles(locales: [$lang], stage: $stage) {
            ...FullVehicle

            customerBenefits {
                ...FullCustomerBenefit

                topics {
                    id
                }
            }

            topics {
                ...FullTopic

                customerBenefits {
                    id
                }
                components {
                    id
                }
            }

            components {
                ...FullComponent

                topics {
                    id
                }
                vehicles {
                    id
                }
            }
        }

        podcasts(locales: [$lang], stage: $stage) {
            ...FullPodcastsFragment
        }

        topicClusters(locales: [$lang], stage: $stage) {
            ...FullTopicCluster

            topics {
                ...FullTopic
            }
        }

        generalTranslations(locales: [$lang], stage: $stage) {
            ...FullGeneralTranslation
        }

        # get how to component explicilty since it is not linked to any vehicle
        component(where: { slug: "how-to" }, locales: [$lang], stage: $stage) {
            ...FullComponent
        }

        entryScreenItems(orderBy: sortIndex_ASC, locales: [$lang], stage: $stage) {
            ...FullEntryScreenItem
        }
    }
    ${FullComponentFragment}
    ${FullCustomerBenefitFragment}
    ${FullTopicFragment}
    ${FullVehicleFragment}
    ${FullTopicClusterFragment}
    ${FullGeneralTranslationFragment}
    ${FullEntryScreenItemFragment}
    ${FullPodcastsFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/allData.js